import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import SearchIcon from '../../assets/images/drop_down_filter.svg';
import './ListFilterComponent.scss';
import { Image, Form } from 'react-bootstrap';

function ListFilterComponent(props) {
  const queryString = require('query-string');
  const location = useLocation();

  const onSearch = props.onSearch || (() => {});

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    const searchKey = form.searchKey.value;
    onSearch(searchKey);
  };
  const [searchKey, setSearchKey] = useState();
  useEffect(() => {
    setSearchKey(queryString.parse(location.search)['search']);
  }, [location]);

  // console.log('@@19: ', defaultValue, searchKey);
  return (
    <Form
      autoComplete="off"
      noValidate
      className="list-filter-list-search-section"
      onSubmit={handleSubmit}
    >
      <Image src={SearchIcon} className="filterable-search-bar-icon search_bar_icon"/>
      <input
        name="searchKey"
        value={searchKey}
        onChange={({ target }) => setSearchKey(target.value)}
        type="text"
        className="list-filter-search-field"
        placeholder={props.searchPlaceholder || "Search by name"}
      />
    </Form>
  );
}

export default ListFilterComponent;
